import { groupsWithCustomFieldsViewName } from '../../../../../../backend/features/groups/shared';
import { useDataTableUsingState } from '@juvare/common-data-table-ui/DataTable';
import { useViewList } from '@juvare/platform-sdk-react/ui/hooks/useViewList';
export function useGroupsWithCustomFieldsTable(customFieldName) {
    const result = useDataTableUsingState({
        useDataProvider: (request) => {
            // Fetch filter-based groups that use custom fields in filters
            const { data: groupData, isLoading: groupLoading, error: groupError, mutate, } = useViewList(groupsWithCustomFieldsViewName, {
                filter: [{ column: 'groupFilters', op: 'overlap', value: ['_dynamic_' + customFieldName] }],
                limit: request.limit,
                offset: request.offset,
            });
            return {
                data: groupData ? { rows: groupData.rows, totalRowCount: groupData.total, filteredRowCount: groupData.total } : undefined,
                error: groupError,
                isLoading: groupLoading,
                reload: mutate,
            };
        },
        defaultSortColumnKey: 'name',
    });
    return Object.assign({}, result);
}
